module.exports = __webpack_public_path__ + "zmenseni-prsou_6_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_6_after.jpg
// module id = 1287
// module chunks = 0